module.exports = __webpack_public_path__ + "media/images/emblems/Kerzers-coat_of_arms-fd6c1157556b2d6b4d80074059994cd7.svg";